import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import {
  Box,
  Button,
  Card,
  CardActionArea,
  Stack,
  Typography,
} from '@mui/material';
import { useNavigate } from 'react-router';
import { TagList, TagListLoading } from './tag-list';
import { useUserPrioritySkillSetsIndex } from '@/data/taxonomy/user-priority-skill-sets';

interface SkillsSectionProps {
  maxVisibleSkills?: number;
  // Hides the description and button, and makes the whole card clickable.
  compact?: boolean;
}

export const SkillsSection = ({
  maxVisibleSkills,
  compact = false,
}: SkillsSectionProps = {}) => {
  const { prioritySkillSets, isLoading: isLoadingSkills } =
    useUserPrioritySkillSetsIndex();
  const navigate = useNavigate();

  const skillTags = prioritySkillSets.map((skill) => ({
    label: skill.name_pt,
  }));

  const navigateToSkillManagement = () => navigate('/gestao-de-habilidades');

  const header = (
    <Typography fontWeight="semibold" variant="h3">
      Habilidades em foco
    </Typography>
  );

  const tags = isLoadingSkills ? (
    <TagListLoading />
  ) : (
    <TagList tags={skillTags} maxVisible={maxVisibleSkills} />
  );

  if (compact) {
    return (
      <Card sx={{ height: '100%' }}>
        <CardActionArea
          onClick={navigateToSkillManagement}
          sx={{ height: '100%', p: 3 }}
        >
          <Stack direction="row" spacing={4} alignItems="center">
            <AutoFixHighIcon sx={{ color: 'primary.dark' }} />
            <Stack spacing={2} flex={1}>
              {header}
              {tags}
            </Stack>
          </Stack>
        </CardActionArea>
      </Card>
    );
  }

  return (
    <Card sx={{ pt: 3, pb: { xs: 2, md: 3 }, px: 3 }}>
      <Box
        display="grid"
        gridTemplateAreas={{
          xs: `"header" "desc" "tags" "edit"`,
          md: `"header edit" "desc desc" "tags tags"`,
        }}
        gridTemplateColumns={{ xs: '1fr', md: '1fr auto' }}
        rowGap={2}
      >
        <Box gridArea="header" display="flex" alignItems="center" gap={2}>
          <AutoFixHighIcon sx={{ color: 'primary.dark' }} />
          {header}
        </Box >
        <Box
          gridArea="edit"
          display="flex"
          alignItems="center"
          justifyContent={{ xs: 'flex-start', md: 'flex-end' }}
        >
          <Button variant="text" onClick={navigateToSkillManagement}>
            Gerenciar habilidades
          </Button>
        </Box>
        <Box gridArea="desc">
          <Typography>
            As habilidades são utilizadas para gerar recomendações de recursos
            para o seu desenvolvimento. Gerencie suas habilidades e gere novas
            recomendações.
          </Typography>
        </Box>
        <Box gridArea="tags">{tags}</Box>
      </Box >
    </Card >
  );
};
